var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconCompassLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconCompass",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M960 0c-29.455 0-53.333 23.878-53.333 53.333v164.425C755.322 243.149 640 374.774 640 533.333c0 35.57 5.803 69.784 16.515 101.748L142.857 1524.76c-78.897 136.66-32.076 311.4 104.579 390.3 16.399 9.46 37.368 3.84 46.835-12.55l297.82-515.84h314.576v106.66c0 29.46 23.878 53.34 53.333 53.34s53.33-23.88 53.33-53.34v-106.66h314.37l297.82 515.84c9.47 16.39 30.44 22.01 46.84 12.55 136.65-78.9 183.48-253.64 104.58-390.3l-513.53-889.454c10.76-32.028 16.59-66.319 16.59-101.973 0-158.559-115.32-290.184-266.67-315.575V53.333C1013.33 23.878 989.455 0 960 0Zm0 320c-117.821 0-213.333 95.513-213.333 213.333 0 117.821 95.512 213.334 213.333 213.334 117.82 0 213.33-95.513 213.33-213.334C1173.33 415.513 1077.82 320 960 320Zm0 533.333c19.41 0 38.417-1.728 56.87-5.039L1266.12 1280h-252.79v-106.67c0-29.45-23.875-53.33-53.33-53.33s-53.333 23.88-53.333 53.33V1280H653.675L902.94 848.261a321.882 321.882 0 0 0 57.06 5.072Zm714.09 919.967-555.41-962.015c31.59-18.077 59.81-41.387 83.47-68.748l482.41 835.563c36.56 63.32 30.04 139.7-10.47 195.2ZM235.233 1578.1l482.493-835.706c23.646 27.379 51.855 50.707 83.445 68.803L245.702 1773.3c-40.51-55.5-47.031-131.88-10.469-195.2Z",
      fillRule: "evenodd"
    })));
  }
}
IconCompassLine.glyphName = 'compass';
IconCompassLine.variant = 'Line';
IconCompassLine.displayName = 'IconCompassLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconCompassLine.propTypes = {
  ...SVGIcon.propTypes
};
IconCompassLine.allowedProps = [...SVGIcon.allowedProps];
export default IconCompassLine;
export { IconCompassLine };